var today = new Date();

function getCutoffDate() {
    var cutoff_date;
    if ($.cookie('mj_last_login_short_term')) {
        // if the user already has a short-term cookie (they are currently browsing the site), use that date for the cutoff and do not alter any cookies
        cutoff_date = new Date($.cookie('mj_last_login_short_term'));
    } else {
        if ($.cookie('mj_last_login')) {
            // if the user just logged onto the site and has been here in the past 14 days, use the mj_last_login cookie
            cutoff_date = new Date($.cookie('mj_last_login'));
        } else {
            // if the user has not visited the site in the past 14 days, set the cutoff date to 14 days ago.
            var days_ago = 14;
            cutoff_date = new Date();
            cutoff_date.setDate(cutoff_date.getDate() - days_ago);
        }
        
        // set the short-term cookie to the cutoff date
        var tomorrow = new Date(); 
        tomorrow = new Date(tomorrow.getTime() + (24 * 60 * 60 * 1000));
        $.cookie('mj_last_login_short_term', cutoff_date.toDateString(), {expires : tomorrow});
        
        // set the mj_last_login date to the current date, expiring in 14 days
        $.cookie('mj_last_login', today.toDateString(), {expires : 14});
    }
    
    return cutoff_date;
}


function determineIfRecentlyAdded(product, cutoff_date) {
    var datestring = product.find('.date-added').val().split(' ')[0];
    // var datestring_split = datestring.split('-');
    var date_added = new Date(datestring);
    return date_added > cutoff_date;
}

function setRecentlyAdded(product) {
    product.addClass('recently-added');
}

$(function() {
    var cutoff_date = getCutoffDate();
    
    $('.thumbnail').each(function() {
        var recent_add = determineIfRecentlyAdded($(this), cutoff_date);
        
        if (recent_add) {
            setRecentlyAdded($(this));
        }
    })
})